import {ACCESS_TOKEN, V1_API_URL_PREFIX} from '../Constants';
import {request} from "./ApiUtils";

export function approvedContractors() {
    return request({
        url: V1_API_URL_PREFIX + "/approved-contractors",
        method: 'GET'
    });
}

export function approvedContractorsRevision() {
    return request({
        url: V1_API_URL_PREFIX + "/approved-contractors/latestRevision",
        method: 'GET'
    });
}

export function saveOrUpdateApprovedContractors(record) {
    return request({
        url: V1_API_URL_PREFIX + "/approved-contractors/update",
        method: 'POST',
        body: JSON.stringify(record)
    });
}

export function deleteApprovedContractors(approvedContractors) {
    const headers = new Headers({
        'Content-Type': 'application/json',
    });

    if (localStorage.getItem(ACCESS_TOKEN)) {
        headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN));
    }

    const defaults = {headers: headers};
    let options = Object.assign({}, defaults, {
        url: V1_API_URL_PREFIX + "/approved-contractors/delete",
        method: 'DELETE',
        body: JSON.stringify(approvedContractors)
    });

    return fetch(options.url, options)
        .then(response => {
                if (response.status !== 204) {
                    return Promise.reject();
                }
                return Promise.resolve();
            }
        );
}

export function addApprovedContractorsRevision(record) {
    return request({
        url: V1_API_URL_PREFIX + "/approved-contractors/add/revision",
        method: 'POST',
        body: JSON.stringify(record)
    });
}
